// Builds a clean, print-optimised alignment sheet in a new window and triggers print.
const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString() : "—");
const val = (v) => (v === "" || v === null || v === undefined ? "—" : `${v}°`);

export function printSession(s) {
  const m = s.measurements || {};
  const rows = [
    ["Front Left", "Camber", val(m.frontLeft?.camber)],
    ["Front Right", "Camber", val(m.frontRight?.camber)],
    ["Front Left", "Caster", val(m.frontLeft?.caster)],
    ["Front Right", "Caster", val(m.frontRight?.caster)],
    ["Front Axle", "Total Toe", val(m.frontToe)],
    ["Rear Left", "Camber", val(m.rearLeft?.camber)],
    ["Rear Right", "Camber", val(m.rearRight?.camber)],
    ["Rear Axle", "Total Toe", val(m.rearToe)],
  ];
  const rate = s.passRate == null ? "—" : `${s.passRate}%`;
  const rateColor = s.passRate == null ? "#64748B" : s.passRate === 100 ? "#0a7d4f" : s.passRate >= 60 ? "#b4790a" : "#c0392b";

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${s.title || "Alignment Report"}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: 'Helvetica Neue', Arial, sans-serif; color: #111; margin: 0; padding: 40px; }
    .brand { font-weight: 800; letter-spacing: 3px; text-transform: uppercase; font-size: 22px; }
    .brand span { color: #0284C7; }
    .sub { color: #666; font-size: 11px; letter-spacing: 2px; text-transform: uppercase; margin-top: 2px; }
    hr { border: none; border-top: 2px solid #111; margin: 16px 0; }
    .meta { display: flex; flex-wrap: wrap; gap: 24px; font-size: 13px; margin-bottom: 8px; }
    .meta b { display:block; font-size: 10px; letter-spacing: 1px; text-transform: uppercase; color:#888; }
    h2 { font-size: 13px; letter-spacing: 2px; text-transform: uppercase; margin: 22px 0 8px; }
    table { width: 100%; border-collapse: collapse; font-size: 13px; }
    th, td { text-align: left; padding: 9px 12px; border-bottom: 1px solid #ddd; }
    th { font-size: 10px; letter-spacing: 1px; text-transform: uppercase; color: #888; }
    td.v { text-align: right; font-family: 'Courier New', monospace; font-weight: 700; }
    .score { display:inline-block; padding: 6px 14px; border-radius: 4px; color:#fff; font-weight:800; font-size: 15px; background:${rateColor}; }
    .notes { margin-top: 18px; font-size: 12px; color:#333; white-space: pre-wrap; border-left:3px solid #0284C7; padding-left:12px; }
    .foot { margin-top: 28px; font-size: 10px; color:#999; }
    @media print { body { padding: 0.5in; } }
  </style></head><body>
    <div class="brand">Thortek <span>Performance</span></div>
    <div class="sub">Wheel Alignment Report</div>
    <hr/>
    <div class="meta">
      <div><b>Session</b>${s.title || "—"}</div>
      <div><b>Date</b>${fmtDate(s.createdAt)}</div>
      ${s.mileage ? `<div><b>Mileage</b>${Number(s.mileage).toLocaleString()} mi</div>` : ""}
      ${s.treadDepth ? `<div><b>Tread</b>${s.treadDepth}</div>` : ""}
      <div><b>Alignment Score</b><span class="score">${rate}</span></div>
    </div>
    <h2>Measured Values</h2>
    <table>
      <thead><tr><th>Position</th><th>Measurement</th><th style="text-align:right">Reading</th></tr></thead>
      <tbody>
        ${rows.map(([p, meas, v]) => `<tr><td>${p}</td><td>${meas}</td><td class="v">${v}</td></tr>`).join("")}
      </tbody>
    </table>
    ${s.notes ? `<div class="notes"><b style="display:block;font-size:10px;letter-spacing:1px;text-transform:uppercase;color:#888;margin-bottom:4px;">Notes</b>${s.notes}</div>` : ""}
    <div class="foot">Generated by Thortek Performance · Readings are user-recorded. Verify safety-critical work on a professional rack.</div>
    <script>window.onload = function(){ setTimeout(function(){ window.print(); }, 250); };</script>
  </body></html>`;

  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
